/**
 * Cart page: update line totals + subtotal when quantity changes (preview until Update cart).
 */
(function() {
  if (window.__cmgpCartLiveTotalsLoaded) return;
  window.__cmgpCartLiveTotalsLoaded = true;

  function moneyFormat() {
    try {
      var el = document.getElementById('wetheme-global');
      if (el) {
        var global = JSON.parse(el.textContent || '{}');
        if (global.moneyFormat) return global.moneyFormat;
      }
    } catch (e) {}
    if (window.Shopify && window.Shopify.money_format) return window.Shopify.money_format;
    return '${{amount}}';
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, moneyFormat());
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function getQty(row) {
    var input = row.querySelector('.cart-page-premium__qty-input');
    if (!input) return 1;
    var qty = parseInt(input.value, 10);
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function updateRow(row) {
    var qty = getQty(row);
    var unitFinal = parseInt(row.getAttribute('data-unit-final'), 10) || 0;
    var unitOriginal = parseInt(row.getAttribute('data-unit-original'), 10) || 0;
    var compareUnit = parseInt(row.getAttribute('data-compare-unit'), 10) || 0;
    var showCompare = row.getAttribute('data-show-compare') === 'true';

    var finalTotal = unitFinal * qty;
    var compareTotal = 0;
    if (showCompare) {
      var base = compareUnit > unitFinal ? compareUnit : unitOriginal;
      compareTotal = base * qty;
    }

    var totalEl = row.querySelector('[data-cart-line-total]');
    var compareEl = row.querySelector('[data-cart-line-compare]');
    var compareWrap = row.querySelector('[data-cart-line-compare-wrap]');

    if (totalEl) totalEl.textContent = formatMoney(finalTotal);
    if (compareEl) compareEl.textContent = formatMoney(compareTotal);
    if (compareWrap) {
      if (showCompare && compareTotal > finalTotal) {
        compareWrap.removeAttribute('hidden');
      } else {
        compareWrap.setAttribute('hidden', '');
      }
    }
  }

  function updateSubtotal() {
    var rows = document.querySelectorAll('[data-cart-line-item]');
    var sumFinal = 0;
    var sumCompare = 0;

    rows.forEach(function(row) {
      var qty = getQty(row);
      var unitFinal = parseInt(row.getAttribute('data-unit-final'), 10) || 0;
      var unitOriginal = parseInt(row.getAttribute('data-unit-original'), 10) || 0;
      var compareUnit = parseInt(row.getAttribute('data-compare-unit'), 10) || 0;
      var showCompare = row.getAttribute('data-show-compare') === 'true';

      sumFinal += unitFinal * qty;
      if (showCompare) {
        var base = compareUnit > unitFinal ? compareUnit : unitOriginal;
        sumCompare += base * qty;
      }
    });

    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    var subtotalCompareEl = document.querySelector('[data-cart-subtotal-compare]');
    var subtotalCompareWrap = document.querySelector('[data-cart-subtotal-compare-wrap]');

    if (subtotalEl) subtotalEl.textContent = formatMoney(sumFinal);
    if (subtotalCompareEl) subtotalCompareEl.textContent = formatMoney(sumCompare);
    if (subtotalCompareWrap) {
      if (sumCompare > sumFinal) {
        subtotalCompareWrap.removeAttribute('hidden');
      } else {
        subtotalCompareWrap.setAttribute('hidden', '');
      }
    }
  }

  function updateAll() {
    document.querySelectorAll('[data-cart-line-item]').forEach(updateRow);
    updateSubtotal();
  }

  function bindCartForm(form) {
    if (!form || form.__cmgpLiveTotalsBound) return;
    form.__cmgpLiveTotalsBound = true;

    form.addEventListener('click', function(e) {
      if (e.target.closest('.js-qty__adjust')) {
        setTimeout(updateAll, 0);
      }
    });

    form.querySelectorAll('.cart-page-premium__qty-input').forEach(function(input) {
      input.addEventListener('input', updateAll);
      input.addEventListener('change', updateAll);
    });

    updateAll();
  }

  function boot() {
    var form = document.querySelector('[data-wetheme-section-type="template--cart"]');
    bindCartForm(form);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
